import { render, staticRenderFns } from "./ed-preview-file-page.vue?vue&type=template&id=194410e7&"
import script from "./ed-preview-file-page.ts?vue&type=script&lang=ts&"
export * from "./ed-preview-file-page.ts?vue&type=script&lang=ts&"
import style0 from "./ed-preview-file-page.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports